import { FlexProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { getCurrentQuote, Proposal } from '../../../../domain'
import { ProductConfig, ProductKind } from '../../../../state/configuration'
import {
  AnnualAdjustedPremium,
  DriveawayAdjustedPremium,
  SubscriptionAdjustedPremium,
} from '../../../organisms/pricing'

export interface PricingSidebarFactoryProps extends FlexProps {
  proposal: Proposal
  product: ProductConfig
  expanded?: boolean
}

export const ProposalSidebarPricing: FunctionComponent<PricingSidebarFactoryProps> = ({
  proposal,
  product,
  expanded,
  ...props
}) => {
  const quote = getCurrentQuote(proposal)

  switch (product.productKind) {
    case ProductKind.ANNUAL:
      return (
        <AnnualAdjustedPremium
          currentQuote={quote}
          product={product}
          expanded={expanded}
          {...props}
        />
      )
    case ProductKind.SUBSCRIPTION:
      return (
        <SubscriptionAdjustedPremium
          currentQuote={quote}
          product={product}
          expanded={expanded}
          {...props}
        />
      )
    case ProductKind.DRIVEAWAY:
      return (
        <DriveawayAdjustedPremium
          currentQuote={quote}
          product={product}
          policyTerm={proposal.policyTerm}
          {...props}
        />
      )
  }
}
